import { render } from "./Geography.vue?vue&type=template&id=ffa9cf1e"
import script from "./Geography.vue?vue&type=script&lang=js"
export * from "./Geography.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__